import { Box, Grid, Switch, Typography } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import SnackBar from "../../../../components/notification/snackbar/snackbar";
import { useAuth0 } from "@auth0/auth0-react";
import ButtonUI from "../../../../components/button/buttons";
import DeleteIcon from "@mui/icons-material/Delete";
import ModalUI from "../../../../components/modalUI/ModalUI";
export const Setting = ({ data, onDeleted }: any) => {
  const [checked, setChecked] = useState<boolean>(!!(data?.is_approve && !data?.is_test));
  const [isActiveAccountchecked, setIsActiveAccountChecked] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [saving, setSaving] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const [snackMessage, setSnackMessage] = useState("");

  const apiUrl = process.env.REACT_APP_API_URL;
  const { getAccessTokenSilently } = useAuth0();

  const profileId = useMemo(() => data?._id || data?.id || null, [data]);

  useEffect(() => {
    setChecked(!!(data?.is_approve && !data?.is_test));
  }, [data]);

  const handleChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!profileId) {
      setSnackMessage("No se encontró el ID del perfil seleccionado.");
      setSnackOpen(true);
      return;
    }
    const newChecked = event.target.checked;
    const payload = { production_enabled: newChecked } as const;

    const prev = checked;
    setChecked(newChecked);
    setSaving(true);

    try {
      const tk = await getAccessTokenSilently();

      await axios.patch(
        `${apiUrl}/api/v1/admin/profile/profile-change/${profileId}`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${tk}`,
          },
        }
      );
      if (data) {
        if (newChecked) {
          data.is_approve = true;
          data.is_test = false;
        } else {
          data.is_approve = false;
          data.is_test = true;
        }
      }
      setSnackMessage(
        newChecked
          ? "API de producción activada"
          : "Modo de prueba activado"
      );
      setSnackOpen(true);
    } catch (err: any) {
      setChecked(prev);
      if (err?.response?.status === 401) {
        setSnackMessage("No autorizado.");
      } else {
        setSnackMessage("No se pudo actualizar la configuración.");
      }
      setSnackOpen(true);
    } finally {
      setSaving(false);
    }
  };

  const OnClickModal = () => {
    setOpenModal(true);
  };

  const handleConfirmDelete = async () => {
    if (!profileId) {
      setSnackMessage("No se encontró el ID del perfil seleccionado.");
      setSnackOpen(true);
      return;
    }
    try {
      setDeleting(true);
      const tk = await getAccessTokenSilently();
      const response: any = await axios.delete(
        `${apiUrl}/api/v1/admin/profile/profile-change/${profileId}`,
        {
          headers: {
            Authorization: `Bearer ${tk}`,
          },
        }
      );
      const del = response?.data?.deleted;
      const summary = del
        ? `Eliminado: transacciones ${del?.transactions ?? 0}, retiros ${del?.withdrawal_transactions ?? 0}, clientes ${del?.customers ?? 0}, cuentas ${del?.accounts ?? 0}, perfil ${del?.profile ?? 1}`
        : "Usuario eliminado";
      setSnackMessage(summary);
      setSnackOpen(true);
      setOpenModal(false);
      if (typeof onDeleted === "function") onDeleted();
    } catch (err: any) {
      const status = err?.response?.status;
      if (status === 400) setSnackMessage("ID no válido.");
      else if (status === 404) setSnackMessage("Usuario no encontrado.");
      else if (status === 401) setSnackMessage("No autorizado.");
      else if (status === 403) setSnackMessage("Sin permisos para eliminar usuarios.");
      else setSnackMessage("No se pudo eliminar el usuario.");
      setSnackOpen(true);
    } finally {
      setDeleting(false);
    }
  };

  const handleChangeActiveAccount = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setIsActiveAccountChecked(event.target.checked);
  };

  return (
    <div>
      <Grid
        container
        spacing={{ xs: 2, md: 3 }}
        columns={{ xs: 4, sm: 8, md: 12 }}
      >
        <Grid item xs={2} sm={4} md={4}>
          <b>Activar API producción</b>
          <br></br>
          <Switch
            checked={checked}
            onChange={handleChange}
            disabled={saving}
            inputProps={{ "aria-label": "controlled" }}
          />
        </Grid>

        <Grid item xs={2} sm={4} md={4}>
          <b>Desactivar Cuenta</b>
          <br></br>
          <Switch
            checked={isActiveAccountchecked}
            onChange={handleChangeActiveAccount}
            inputProps={{ "aria-label": "controlled" }}
          />
        </Grid>

        <Grid item xs={2} sm={4} md={4}>
          <b>Borrar cuenta</b>
          <br></br>
          <ButtonUI
            title="Borrar cuenta"
            icon={<DeleteIcon />}
            color="error"
            onClick={() => OnClickModal()}
          />
        </Grid>
      </Grid>
      <ModalUI open={openModal} setOpen={setOpenModal}>
        <Box>
          <Box sx={{ padding: "5px" }}>
            <Typography variant="h5" align="center" color="error">
              ¿Estás seguro de que deseas borrar esta cuenta?{" "}
            </Typography>
            <Typography variant="body1" align="center">
              <b>¡Atención!</b> Estás a punto de borrar esta cuenta. Ten en
              cuenta que esta acción es irreversible y se perderan todos los
              dato
            </Typography>

            <Typography variant="body1" align="center">
              ¿Deseas continuar?
            </Typography>
          </Box>
          <Box
            sx={{
              justifyContent: "center",
              alignContent: "center",
              display: "flex",
              padding: "5px",
            }}
          >
            <ButtonUI title="No borrar" onClick={() => setOpenModal(false)}  />
            <ButtonUI title={deleting ? "Eliminando..." : "Borrar"} color="error" icon={<DeleteIcon />}  disabled={deleting} onClick={handleConfirmDelete}  />
          </Box>
        </Box>
      </ModalUI>
      <SnackBar
        open={snackOpen}
        message={snackMessage}
        duration={4000}
        onClose={() => setSnackOpen(false)}
      />
    </div>
  );
};
